import React from 'react';

import {
  NumberInput as ChakraNumberInput,
  NumberInputProps as ChakraNumberInputProps,
  NumberInputField,
  forwardRef,
} from '@chakra-ui/react';
import styled from '@emotion/styled';

type InputProps = ChakraNumberInputProps;

const StyledInput = styled(NumberInputField)`
  font-weight: normal;
  border-bottom: 1px solid #999999;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  border-radius: 4px 4px 0px 0px;
  background: transparent;
  padding: 10px 12px;
  border-bottom-style: dashed;
  &:hover {
    border-bottom: 1px solid #333333;
  }
  &:focus {
    /* background: white; */
    border-bottom: 1px solid #1565bc;
    /* box-shadow: 0px 2px 4px rgba(0, 142, 240, 0.1); */
    box-shadow: none;
  }
  &[aria-invalid='true'] {
    border-bottom: 1px solid #c62c02;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    box-shadow: none;
    background: transparent;
    &:focus {
      /* background: white;
      box-shadow: 0px 2px 4px rgba(207, 102, 121, 0.1); */
      box-shadow: none;
    }
  }
  font-size: 14px;
`;

const NumberInput = forwardRef<InputProps, 'input'>(({ ...props }, ref) => (
  <ChakraNumberInput {...props} className={`mesh-dotted-input ${props.className ?? ''}`}>
    <StyledInput ref={ref} _placeholder={{ color: '#666666' }} />
  </ChakraNumberInput>
));

export { NumberInput };
